export default __webpack_public_path__ + "static/logo-hover-green-6fc244bdccec5a2a7d30172724f7e962.svg";